import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import { faCaretDown, faCaretRight, faRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ReactComponent as Logo } from "assets/logo.svg"
import OutsideClick from "components/Shared/OutsideClick/OutsideClick"
import ToggleButtonMenu from "components/Shared/ToggleButtonMenu/ToggleButtonMenu"
import { setSidebarStatus } from "features/sidebar/sidebarSlice"
import { useAppDispatch, useAppSelector } from "hooks/hooksStore"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { destroyAccessToken, removeRefreshToken } from "../../../utils/token"
import PackageJSON from "../../../../package.json"

function Navbar() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const UserData = sessionStorage.getItem("UserEmail")

  // State
  const [isOpenUserProfile, setIsOpenUserProfile] = useState<boolean>(false)

  // Redux State
  const isOpenSidebar = useAppSelector(state => state.sidebar.open)

  // Functions
  const handleClickUser = () => {
    setIsOpenUserProfile((prev: boolean) => !prev)
  }

  const handleLogout = () => {
    destroyAccessToken()
    removeRefreshToken()
    sessionStorage.removeItem("UserEmail")

    if (isAuthenticated) {
      instance.logoutRedirect()
      return
    }

    navigate("/")
  }

  const closeUse = () => setIsOpenUserProfile(false)

  return (
    <div className="navbar">
      <div className="navbar-header">
        <div className="d-flex align-center justify-between">
          <Logo width="80" height="50" />
          <div>
            <h1>Data Bridges</h1>
            <h6 style={{ fontSize: "12px", color: "white" }}>{PackageJSON.version}</h6>
          </div>

          <ToggleButtonMenu action={() => dispatch(setSidebarStatus(!isOpenSidebar))} />
        </div>
      </div>

      <div className="d-flex align-center justify-between">
        <OutsideClick callback={closeUse}>
          <div className="navbar-user mr-3" onClick={handleClickUser} aria-hidden="true">
            <span className="navbar-user--avatar cursor-pointer">
              <FontAwesomeIcon icon={faUser} className="primary-color" />
            </span>
            <span className="navbar-user--username">{UserData}</span>
            <span className="navbar-user--caret">
              <FontAwesomeIcon icon={isOpenUserProfile ? faCaretDown : faCaretRight} className="white-color fs-13" />
            </span>
            {isOpenUserProfile && (
              <div className="navbar-user-dropdown">
                <div className="navbar-user-dropdown--actions">
                  <div
                    className="flex items-center gap-2 px-2 py-1.5 text-sm font-semibold text-slate-900 transition-colors hover:bg-blue-50 rounded-md"
                    onClick={() => navigate("/User/Profile")}
                    aria-hidden="true"
                  >
                    <FontAwesomeIcon icon={faUser} className="text-sm text-slate-700" />
                    {t("Profile")}
                  </div>
                  <div
                    className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm font-semibold text-[var(--support-01)] transition-colors hover:bg-red-100"
                    onClick={handleLogout}
                    aria-hidden="true"
                  >
                    <FontAwesomeIcon icon={faRightFromBracket} className="text-sm text-[var(--support-01)]" />
                    {t("logout")}
                  </div>
                </div>
              </div>
            )}
          </div>
        </OutsideClick>
        {/* <SelectLanguage /> */}
      </div>
    </div>
  )
}

export default Navbar
